/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import * as S from "./styles";
import Logo from "../../assets/imagens/logo_de_grao_em_pao_azul.png";
import BtAndroid from "../../assets/imagens/disponivel-google-play.png";
import BtIos from "../../assets/imagens/disponivel-na-app-store.png";
import Phone from "../../assets/imagens/aplicativo.png";

const App = () => {
  document.title = "De Grão em Pão | Aplicativo";
  const LinkAndroid = "https://play.google.com/store/apps/details?id=com.omnion.appdegraoempao";
  const LinkIos = "https://apps.apple.com/us/app/de-gr%C3%A3o-em-p%C3%A3o/id6747897655";
  return (
    <S.Container>
      <S.ContainerApp>
        <div className="container">
          <div className="content">
              <div className="download-info">
                <div className="logo">
                    <img src={Logo} alt="De Grão em Pão" />
                </div>
                <p>Disponível para download na Google Play Store e Apple App Store!</p>                
                <div className="download-buttons">
                    <a href={LinkAndroid} className="download-btn"> <img src={BtAndroid} alt="Disponível no Google Play" /> </a>
                    <a href={LinkIos} className="download-btn"> <img src={BtIos} alt="Baixe na App Store" /> </a>
                </div>
              </div>
              <div className="phone-image">
                  <img src={Phone} alt="Aplicativo no celular" />
              </div>
          </div>
      </div>
      </S.ContainerApp>
    </S.Container>
  );
};

export default App;